import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  emptyPooledPlateInputErrorMessage: {
    id: 'emptyPooledPlateInputErrorMessage',
    defaultMessage: 'Pooled plate volume is required!',
  },
  minNrVolumeErrorMessage: {
    id: 'minNrVolumeErrorMessage',
    defaultMessage: `The volume specified for the pooled plate is outside of the allowed range. 
      Please specify a pooled plate volume between 10 and 12.`,
  },
  maxNrVolumeErrorMessage: {
    id: 'maxNrVolumeErrorMessage',
    defaultMessage: `The volume specified for the pooled plate is outside of the allowed range. 
      Please specify a pooled plate volume between 10 and 12.`,
  },
  noNumberErrorMessagePooledPlate: {
    id: 'noNumberErrorMessagePooledPlate',
    defaultMessage: 'Pooled plate volume should contain only numbers!',
  },
  pooledPlateVolume: {
    id: 'pooledPlateVolume',
    defaultMessage: 'Pooled plate volume (uL)',
  },
  pooledPlates: {
    id: 'pooledPlates',
    defaultMessage: 'Pooled plates',
  },
  pooledPlateName: {
    id: 'pooledPlateName',
    defaultMessage: 'Pooled plate name',
  },
  emptyPooledPlateNameError: {
    id: 'emptyPooledPlateNameError',
    defaultMessage: 'Pooled plate name is required!',
  },
  poolingPlates: {
    id: 'poolingPlates',
    defaultMessage: 'Plates for pooling',
  },
  addBtn: {
    id: 'addBtn',
    defaultMessage: 'Add',
  },
  removeBtn: {
    id: 'removeBtn',
    defaultMessage: 'Remove',
  },
  pooledPlatesOddInfo: {
    id: 'pooledPlatesOddInfo',
    defaultMessage: 'You need to have an even number of plates and select ' +
     'Volume and Concentration in Normalization and Aliquots step to enable this option.'
  },
});

export default { ...generalMessages, ...messages };
